export function isValidJsonString(str: string): boolean {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}
export function isValidJsonObject(value: unknown): boolean {
  try {
    if (value === undefined) return false;
    JSON.stringify(value);
    return true;
  } catch {
    return false;
  }
}
